<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAppointmentAutoKeyDetails</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>
      <div class="scrollbar">
        <div class="card-content" *ngIf="autoKeyDetails">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-6 af-form-group">
                <label translate>lblDealersName</label>
                <div class="lbl-info">{{autoKeyDetails.dealerName}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblCustomerName</label>
                <div class="lbl-info">{{autoKeyDetails.customerName}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblMobile</label>
                <div class="lbl-info">{{autoKeyDetails.mobile}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblId</label>
                <div class="lbl-info">{{autoKeyDetails.id}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblRegNumber</label>
                <div class="lbl-info">
                  <div class="flmid">
                    <div class="licplate LPNo d-flex">
                      <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                      {{autoKeyDetails.licensePlate}}
                    </div>
                    <div class="imgWid">
                      <ng-container>
                        <img af-brand-logo [data-code]="autoKeyDetails.brandCode" data-type="BRAND"
                          class="{{autoKeyDetails.brand.name}}-icon common" [title]="autoKeyDetails.brandCode"
                          class="brandicon" alt="img" />
                      </ng-container>  
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblCarModel</label>
                <div class="lbl-info">{{autoKeyDetails.model}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblWoNo</label>
                <div class="lbl-info">{{autoKeyDetails.workorderNumber}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblWoStatus</label>
                <div class="lbl-info">
                  <div class="color-box" style="background-color: #ccc;"
                    [style.background-color]="autoKeyDetails.workOrderStatusColor"></div>
                  {{autoKeyDetails.status}}
                </div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblBookedDate</label>
                <div class="lbl-info">{{autoKeyDetails.appointmentDate}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblKioskLockerNumber</label>
                <div class="lbl-info"> {{autoKeyDetails.lockerId}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblAssignedLockerDate</label>
                <div class="lbl-info">{{autoKeyDetails.date | date:'short'}}</div>
              </div>

              <div class="col-6 af-form-group">
                <label translate>lblExchangeMethod</label>
                <div class="lbl-info">{{autoKeyDetails.exchangeMethod}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>